export default {
  data() {
    return {
      bloqueioSistema: false,
      bloqueioSistemaResouce: this.$api.bloqueioSistema(this.$resource),
    };
  },
  methods: {
    verificaBloqueioSistema() {
      this.bloqueioSistemaResouce.pesquisar()
      .then((response) => {
        if (response.data) {
          this.bloqueioSistema = true;
          this.mostrarMensagemBloqueio();
        }
      })
      .catch(() => {});
    },
    mostrarMensagemBloqueio() {
      this.$toast.create(this.$t('message.bloqueio_sistema'), 'snack', 3E3);
    },
  },
  mounted() {
    this.verificaBloqueioSistema();
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/bloqueiosistema/bloqueioSistemaMixin.js